// Thin client for /api/hands-free/event. Fire-and-forget — analytics
// must never block the user's practice flow, so all errors are swallowed
// (and logged) rather than surfaced.
import axios from "axios";
import logger from "./logger";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Record a hands-free lifecycle event.
 * @param {object} payload
 * @param {string} payload.intervention_type - e.g. "fear_of_sleeplessness"
 * @param {"opted_in"|"paused"|"resumed"|"stopped"|"completed"} payload.event_type
 * @param {number} [payload.task_index] - 1-based task number (1..9)
 * @param {string} [payload.current_node_id]
 * @param {string} [payload.reason]
 */
export function trackHandsFreeEvent(payload) {
  try {
    axios.post(`${API}/hands-free/event`, payload).catch((err) => {
      logger.warn("hands-free analytics failed", err?.message);
    });
  } catch (err) {
    logger.warn("hands-free analytics threw", err?.message);
  }
}
